import React from 'react';
import { styled } from '@glitz/react';
import ArticleListItemViewModel from 'Shared/ViewModels/ContentListItemViewModel.type';
import { Ratio as ImageRatio } from 'Shared/AspectRatio';
import { Preset as ImagePreset } from 'Shared/image-sizes';
import Link from 'Shared/Link';
import Image from 'Shared/Image/Ratio';
import { ResponsiveSize, TextBlock, TextLabel } from 'Shared/SharedComponents/atoms/Typography';
import * as style from 'Shared/Style';

type PropType = {
  article: ArticleListItemViewModel;
};

const ArticleLink = styled(Link, {
  color: style.colors.monochrome.black,
});

const Wrap = styled.div({
  backgroundColor: style.colors.monochrome.extraLightGrey,
  paddingLeft: '8px',
  display: 'flex',
  flexDirection: 'row',
  borderRadius: '8px'
})

const Content = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  padding: { xy: '8px'},
})

const ArticleCard = ({ article }: PropType) => {
  return (
    <div>
      <ArticleLink to={article.url}>
        <Wrap>
          <div>
            <Image
              src={article.image}
              alt={''}
              ratio={ImageRatio.OneToOne}
              preset={ImagePreset.SquareListItem}
              breakPoint={0}
              borderRadius={8}
              css={{ width: '97px' }}
            />
          </div>
          <Content>
            <TextLabel>{article.tag}</TextLabel>
            <TextBlock fontSize={ResponsiveSize.D16_M16}>{article.heading}</TextBlock>
          </Content>
        </Wrap>
      </ArticleLink>
    </div>
  );
};

export default ArticleCard;
